export default "__VITE_ASSET__GzGPGGKM__"